import { NgModule } from '@angular/core';
import { ListPage } from './pages/list/list.page';
import { CompanyRoutingModule } from './company-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { CreatePage } from './pages/create/create.page';
import { DetailsPage } from './pages/details/details.page';
import { EditPage } from './pages/edit/edit.page';
import { FormComponent } from './components/form/form.component';
import { UsersPage } from './pages/users/users.page';
import { UsersInvitePage } from './pages/users-invite/users-invite.page';



@NgModule({
  declarations: [
    ListPage,
    CreatePage,
    DetailsPage,
    EditPage,
    UsersPage,
    UsersInvitePage,
    FormComponent,
  ],
  imports: [
    CompanyRoutingModule,
    SharedModule,
  ]
})
export class CompanyModule { }
